import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import InlineCenterSkeleton from '@glass/web/components/Skeleton/InlineCenterSkeleton';
import CardActions from '@glass/web/components/base/CardActions';
import CardHeader from '@glass/web/components/base/CardHeader';
import NoSsr from '@glass/web/components/base/NoSsr';
import Paper from '@glass/web/components/base/Paper';

import getUserCardHeaderProps from '@glass/shared/components/Profile/getUserCardHeaderProps';

const useHeaderProps = (user) => useMemo(() => getUserCardHeaderProps(user), [user]);

function TitleLoading() {
  return (
    <span>
      <InlineCenterSkeleton inline width={130} /> <InlineCenterSkeleton inline width={150} />
    </span>
  );
}

function UserProfileCard({ action, children, user, actions, loading }) {
  const { title, subheader, avatar } = useHeaderProps(user);
  const subheaderLoading = <InlineCenterSkeleton width={170} />;
  return loading || user ? (
    <Paper variant="outlined">
      <CardHeader
        action={action}
        avatar={
          loading ? <InlineCenterSkeleton height={40} variant="circular" width={40} /> : avatar
        }
        subheader={
          loading ? subheaderLoading : <NoSsr fallback={subheaderLoading}>{subheader}</NoSsr>
        }
        title={loading ? <TitleLoading /> : title}
      />
      {children}
      {actions ? <CardActions>{actions}</CardActions> : null}
    </Paper>
  ) : null;
}

UserProfileCard.propTypes = {
  action: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  loading: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  user: PropTypes.object,
};

export default React.memo(UserProfileCard);
